export default "__VITE_ASSET__42c34908__"